<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <!-- <img src="@/assets/img/logo_white.png" /> -->
        <img src="@/assets/img/logo_black.png" />
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li v-for="(item, index) in navList" :key="index" :class="activeMenu == item.path ? 'active' : ''">
          <router-link :to="item.path" @click="navClick(item)">
            {{ item.name }}
            <i class="underline"></i>
          </router-link>
          <div class="hd-droupDownMenu" v-if="item.path == 'product'">
            <div class="productMenu">
              <div v-for="pt in productLists" :key="pt.name" class="product-item">
                <div class="type-tl">{{ pt.name }}</div>
                <div v-for="litItem in pt.children" :key="litItem.title" class="product-list-item">
                  <router-link :to="litItem.moreName">{{
          litItem.title
        }}</router-link>
                  <img :src="litItem.img" />
                </div>
              </div>
            </div>
          </div>
          <div class="hd-droupDownMenu" v-if="item.path == 'service'">
            <div class="serviceMenu">
              <router-link class="service-item" v-for="service in item.children" :key="service.name" :to="service.moreName">
                <div class="service-tl">{{ service.name }}</div>
                <div class="service-des font-s">{{ service.des }}</div>
              </router-link>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <img class="center-block" src="@/assets/img/logo_black.png" alt="logo" />
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        {{ menuName }}
        <div class="header-nav-m-menu-wrapper" data-toggle="collapse" data-target="#menu" @click="menuClick">
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li v-for="(item, index) in navList" :key="index" :class="activeMenu == item.path ? 'active' : ''" @click="navClick(item)" data-toggle="collapse" data-target="#menu">
            <router-link :to="item.path">
              {{ item.name }}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { productList } from "@/store/product";
export default {
  name: "Header",
  props: {
    // 接收父组件参数
    colorTheme: {
      type: String,
      required: false,
      default: "white",
    },
  },
  data() {
    return {
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      activeMenu: '',
      navList: [
        {
          name: "首 页",
          path: "home",
          children: [],
        },
        {
          name: "专业产品",
          path: "product",
        },
        {
          name: "相关服务",
          path: "service",
          children: [
            {
              name: "航测服务",
              des: "无人机航测，激光雷达测量，为您提供各种专属数据",
              moreName: "AerialService",
            },
            {
              name: "三维扫描服务",
              des: "提供三维扫描服务，解决企业三维实现需求",
              moreName: "3DScanService",
            },
            {
              name: "三维模型制作服务",
              des: "高清倾斜摄影模型，高质量人工模型",
              moreName: "modelService",
            },
          ],
        },
        {
          name: "解决方案",
          path: "solution",
          children: [],
        },
        {
          name: "关于我们",
          path: "companyintroduction",
          children: [],
        },
        /*   {
          name: "工作机会",
          path: "/jobchance",
          children: []
        }, */
        {
          name: "联系我们",
          path: "contactus",
          children: [],
        },
      ],
      productLists: productList,
    };
  },
  methods: {
    navClick(item) {
      this.menuName = item.name;
      this.activeMenu = item.path;
    },
    changeActiveMenu(name) {
      var menus = ['home', 'product', 'service', 'solution', 'companyintroduction', 'contactus'];
      var menuNames = ['首 页', '专业产品', '相关服务', '解决方案', '关于我们', '联系我们'];
      var i = menus.findIndex(menu => menu == name)
      if (i >= 0) {
        this.activeMenu = menus[i];
        this.menuName = menuNames[i];
      } else {
        if (name.indexOf('product') > -1) {
          this.activeMenu = 'product';
          this.menuName = '专业产品';
        } else if (name.indexOf('Service') > -1 || name.indexOf('service') > -1) {
          this.activeMenu = 'service';
          this.menuName = '相关服务';
        }
      }

    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
  },
};
</script>
<style scoped>
/* 顶部 */
#header {
  background: #f4f4f4;
  transition: all ease 0.6s;
}

#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}

/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}

/* 导航栏 */
#header .header-nav {
  height: 110px;
}

/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 144px;
  height: 100%;
  float: left;
  position: relative;
}

/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 144px;
  height: 45px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}

#header .header-nav .header-nav-wrapper {
  line-height: 110px;
  float: right;
  margin: 0;
  max-width: 800px;
}

/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper>li {
  float: left;
  padding: 0 20px;
  /* position: relative; */
}

/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper>li>a {
  color: #000;
  font-size: 15px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
}

/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper>li>a>i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #1e73be;
}

/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper>li>a>span {
  font-size: 12px;
  transition: transform ease 0.5s;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper>li:hover>a {
  color: #1e73be;
  text-decoration: none;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper>li:hover>a .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover span {
  transform: rotate(180deg);
}

/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper>li.active>a {
  color: #1e73be;
  text-decoration: none;
  border-bottom: 2px solid #1e73be;
}

/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper>li>dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper>li>dl>dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper>li>dl>dt>a:hover {
  text-decoration: none;
}

/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper>li:hover dl {
  display: block;
}

#header .header-nav .header-nav-wrapper>li>dl>dt:hover {
  cursor: pointer;
  background: #ccc;
}

/* 导航栏下拉菜单 */
.header-nav-wrapper>li:hover .hd-droupDownMenu {
  display: block;
  animation-name: sliperOpen;
  animation-duration: 0.3s;
  animation-delay: 0s;
}

.hd-droupDownMenu {
  position: absolute;
  left: 0;
  top: 110px;
  width: 100%;
  z-index: 9;
  display: none;
  overflow: hidden;
  line-height: 30px;
  background: #fff;
  box-shadow: 0 3px 5px #aaa;
  /* transition: all 0.5s linear 1s; */
  animation-name: sliperIn;
  animation-duration: 0.3s;
  animation-delay: 02s;
}

@keyframes sliperOpen {
  0% {
    height: 200px;
  }

  100% {
    height: 240px;
  }
}

@keyframes sliperIn {
  0% {
    height: 240px;
  }

  100% {
    height: 200px;
  }
}

.productMenu {
  width: 1170px;
  margin: 0 auto;
  margin-top: 30px;
  margin-bottom: 50px;
  display: flex;
  justify-content: space-around;
}

.product-item {
  width: 300px;
  padding-left: 190px;
  position: relative;
}

.product-list-item:hover img {
  display: block;
}

.product-list-item img {
  width: 180px;
  position: absolute;
  top: 0px;
  display: none;
  background: #fff;
  left: 0px;
}

.product-item:nth-child(1) img {
  top: -20px;
}

.product-item:nth-child(3) img {
  top: -20px;
}

.product-list-item:nth-child(2) img {
  display: block;
}

.product-list-item a {
  color: #555;
}

.product-item .type-tl {
  font-weight: bold;
  font-size: 18px;
}

/* 相关服务 */
.serviceMenu {
  width: 1170px;
  margin: 0 auto;
  margin-top: 30px;
  margin-bottom: 50px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.service-item {
  width: 280px;
  height: 110px;
  padding: 15px;
  border-right: 2px solid #eee;
}

.service-item:last-child {
  border-right: none;
}

.service-tl {
  color: #333;
  text-decoration: none;
  font-size: 18px;
  margin-bottom: 10px;
}

.service-des {
  line-height: 20px;
  color: #888;
}

/* 深色主题 */
#header.blackTheme {
  position: relative;
  background: rgba(0, 0, 0, 0.3);
}

#header.blackTheme .header-nav .header-nav-wrapper>li>a {
  color: #fff;
}

/* 导航栏 每个导航下面的 a 链接的下划线 */
#header.blackTheme .header-nav .header-nav-wrapper>li>a>i {
  background-color: #fff;
}

#header.blackTheme .header-nav .header-nav-wrapper>li.active>a {
  color: #fff;
  text-decoration: none;
  border-bottom: 2px solid #fff;
}

@media only screen and (max-width: 1400px) {
  .hd-droupDownMenu {
    display: none !important;
  }
}

@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }

  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 55px;
    position: relative;
  }

  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    height: 40px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }

  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 16px;
    line-height: 50px;
    background: #474747;
    position: relative;
  }

  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -22px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
  }

  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    color: #ebeff2;
    padding-bottom: 5px;
    z-index: 9999999;
  }

  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper>li {
    height: 45px;
    line-height: 45px;
    border-top: 1px solid #606664;
  }

  #header .header-nav-m .header-nav-m-wrapper>li.active a {
    color: #337ab7;
  }

  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper>li>a {
    color: #fff;
    padding: 15px 0;
    position: relative;
  }

  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper>li>a>span {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue